import React, { useEffect, useRef, useState } from "react";
import "cropperjs/dist/cropper.css";
import { CircularProgress, Grid, IconButton, Popper, Slider } from "@material-ui/core";
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import RotateRightIcon from "@material-ui/icons/RotateRight";
import ClearIcon from "@material-ui/icons/Clear";
import CheckIcon from "@material-ui/icons/Check";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import Cropper from "cropperjs";
import { useCallback } from "react";

export const ProfileImageCroppingTool = ({ src, shape, onCropped, onCancel, fileType, height, width }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [cropperInstance, setCropperInstance] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(0);
  const [minZoomLevel, setMinZoomLevel] = useState(0);
  const imageRef = useRef();
  const wrapperRef = useRef();
  useEffect(() => {
    if (imageRef?.current) {
      imageRef.current.addEventListener("zoom", onZoomChanged);
    }
    return () => {
      if (imageRef?.current) {
        imageRef.current.removeEventListener("zoom", onZoomChanged);
      }
    };
  });

  useEffect(() => {
    return () => {
      cleanupCallback();
    }
  }, []);
  const cleanupCallback = useCallback(() => {
    if (cropperInstance) cropperInstance.destroy();
  }, [cropperInstance])
  const onZoomChanged = ({ detail }) => {
    setZoomLevel(detail.ratio);
  };

  const initCropper = () => {
    const cropInst = new Cropper(imageRef?.current, {
      viewMode: 0,
      dragMode: "move",
      guides: true,
      autoCrop: true,
      autoCropArea: 1,
      cropBoxMovable: false,
      aspectRatio: `${width} / ${height}`,
      cropBoxResizable: false,
      toggleDragModeOnDblclick: false,
      minContainerHeight: 10,
      minContainerWidth: 10,
      responsive: false,
      ready: () => {
        setMinZoomLevel(cropInst.getContainerData().height / cropInst.getCanvasData().naturalHeight);
        cropInst.setCropBoxData({ left: 1, top: 1, width: width - 1, height: height - 2 })
        setIsLoading(false);
      },
    });
    setCropperInstance(cropInst);
  };

  const getCroppedImage = useCallback(() => {
    if (shape === "circle") {
      const sourceCanvas = cropperInstance.getCroppedCanvas();
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      var width = sourceCanvas.width;
      var height = sourceCanvas.height;

      canvas.width = width;
      canvas.height = height;
      context.imageSmoothingEnabled = true;
      context.drawImage(sourceCanvas, 0, 0, width, height);
      context.globalCompositeOperation = "destination-in";
      context.beginPath();
      context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
      context.fill();
      return canvas.toDataURL();
    } else {
      return cropperInstance.getCroppedCanvas(fileType === "image/jpeg" ? { fillColor: "#fff" } : {}).toDataURL(fileType, 0.8);
    }
  }, [cropperInstance]);

  const handleZoomSlider = (event, newValue) => {
    if (newValue - zoomLevel != 0) {
      cropperInstance.zoom(newValue - zoomLevel);
    }
  };

  const zoomIn = () => cropperInstance.zoom(0.1);
  const zoomOut = () => cropperInstance.zoom(-0.1);

  const handleSave = () => {
    setIsLoading(true);
    onCropped(getCroppedImage());
  };
  return (
    <>
      <div ref={wrapperRef} className={shape === "circle" ? "rounded-crop" : ""} style={{ width, height, position: "relative" }}>
        {isLoading ? (
          <div style={{ position: "absolute", inset: 0, background: "transparent", zIndex: 5000 }}>
            <CircularProgress style={{ position: "absolute", inset: "calc(50% - 20px)", background: "transparent" }} />{" "}
          </div>
        ) : null}
        <img src={src} style={{ display: "block", width: "100%", aspectRatio: `${width} / ${height}` }} ref={imageRef} onLoad={initCropper} />
      </div>
      {wrapperRef?.current ? (
        <Popper id={+new Date()} open={true} anchorEl={wrapperRef?.current} style={{ marginTop: "10px", zIndex: 1000 }}>
          <div className={`croppie-controllers pi-crop`} style={{ width: "fit-content", marginTop: 0, marginLeft: "auto", marginRight: "auto" }}>
            <Grid container spacing={2} style={{ alignItems: "center" }}>
              <Grid item>
                <IconButton style={{ padding: "8px", margin: "0 5px" }} onClick={() => cropperInstance.rotate(-45)}>
                  <RotateLeftIcon tooltip="RotateImage" />
                </IconButton>
                <IconButton style={{ padding: "8px", margin: "0 5px" }} onClick={() => cropperInstance.rotate(45)}>
                  <RotateRightIcon tooltip="RotateImage" />
                </IconButton>
                <IconButton style={{ padding: "8px", margin: "0 5px" }} onClick={handleSave}>
                  <CheckIcon tooltip="SaveChanges" />
                </IconButton>
                <IconButton style={{ padding: "8px", margin: "0 5px" }} onClick={onCancel}>
                  <ClearIcon name="CLOSE" tooltip="Cancel" />
                </IconButton>
              </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center" justifyContent="space-between">
              <Grid className="flex" item>
                <IconButton style={{ padding: "8px" }} onClick={zoomOut}>
                  <ZoomOutIcon name="ZOOMOUT" />
                </IconButton>
              </Grid>
              <Grid className="flex" item xs>
                <Slider size="small" value={zoomLevel} min={minZoomLevel} max={2} step={0.1} onChange={handleZoomSlider} aria-labelledby="zoom-slider" />
              </Grid>
              <Grid className="flex" item>
                <IconButton style={{ padding: "8px" }} onClick={zoomIn}>
                  <ZoomInIcon name="ZOOMIN" />
                </IconButton>
              </Grid>
            </Grid>
          </div>
        </Popper>
      ) : null}
    </>
  );
};
